<template>
  <div class="contq">
    <div v-if="favoritePost">
      <h3 class="title">Saved Posts</h3>
      <div v-for="(favorite, index) in favoritePost" :key="index">
        <FavPost v-if="favorite.favorite[0].content_type === 'post'" :postData="favorite.favorite[0]"></FavPost>
      </div>
      <span
        class="viewmore"
        v-if="favoritePost.length < paginationPost.total_count"
        :style="{ color: getPrimaryColor(), textAlign: 'center', display: 'block', cursor: 'pointer' }"
        @click="fetchPost(true)"
      >
        More Posts
      </span>
    </div>
    <div v-if="!favoritePost">
      <h3 class="title">Saved Posts</h3>
      <div class="dailogbox">
        <div class="dailog-wrapper">
          <span class="dailog">
            <span class="dailog text-capitalize">
              {{
                viewUser.role === "doctor" || viewUser.role === "hcp" ? viewUser.first_name + " " + viewUser.last_name : viewUser.role === "nfp" ? viewUser.nfp_info.nfp_name : viewUser.display_name
              }}
            </span>
            has not saved any posts yet.
          </span>
        </div>
      </div>
    </div>

    <div v-if="favoriteQA">
      <h3 class="title">Saved Questions</h3>
      <div v-for="(favorite, index) in favoriteQA" :key="index">
        <Question v-if="favorite.favorite[0].content_type === 'question'" :quesData="favorite.favorite[0]" />
      </div>
      <span class="viewmore" v-if="favoriteQA.length < paginationQA.total_count" :style="{ color: getPrimaryColor(), textAlign: 'center', display: 'block', cursor: 'pointer' }" @click="fetchQA(true)">
        More Questions
      </span>
    </div>
    <div v-if="!favoriteQA">
      <h3 class="title">Saved Questions</h3>
      <div class="dailogbox">
        <div class="dailog-wrapper">
          <span class="dailog">
            <span class="dailog text-capitalize">
              {{
                viewUser.role === "doctor" || viewUser.role === "hcp" ? viewUser.first_name + " " + viewUser.last_name : viewUser.role === "nfp" ? viewUser.nfp_info.nfp_name : viewUser.display_name
              }}
            </span>
            has not saved any questions yet.
          </span>
        </div>
      </div>
    </div>

    <div v-if="favoritePoll">
      <h3 class="title">Saved Polls</h3>
      <div v-for="(favorite, index) in favoritePoll" :key="index">
        <UserPollCard v-if="favorite.favorite[0].content_type === 'poll'" :pollData="favorite.favorite[0]" />
      </div>
      <span
        class="viewmore"
        v-if="favoritePoll.length < paginationPoll.total_count"
        :style="{ color: getPrimaryColor(), textAlign: 'center', display: 'block', cursor: 'pointer' }"
        @click="fetchPoll(true)"
      >
        More Polls
      </span>
    </div>
    <div v-if="!favoritePoll">
      <h3 class="title">Saved Polls</h3>
      <div class="dailogbox">
        <div class="dailog-wrapper">
          <span class="dailog">
            <span class="dailog text-capitalize">
              {{
                viewUser.role === "doctor" || viewUser.role === "hcp" ? viewUser.first_name + " " + viewUser.last_name : viewUser.role === "nfp" ? viewUser.nfp_info.nfp_name : viewUser.display_name
              }}
            </span>
            has not saved any polls yet.
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../../repositories/RepositoryFactory"
import FavPost from "../../../home/Post"
import Question from "../../Patient/QA/Question"
import UserPollCard from "../../../home/poll/UserPollCard.vue"

const UserRepository = RepositoryFactory.get("user")

export default {
  name: "PatientFavorites",
  components: {
    FavPost,
    Question,
    UserPollCard,
  },
  data() {
    return {
      favorites: [],
      favoritePost: [],
      favoriteQA: [],
      favoritePoll: [],
      paginationPost: null,
      paginationQA: null,
      paginationPoll: null,
      currentPagePost: 1,
      currentPageQA: 1,
      currentPagePoll: 1,
      pagination: null,
      currentPage: 1,
      limit: 5,
      showNo: false,
    }
  },

  created() {
    console.warn("ViewDoctorFavorites.vue is created")
    this.fetchPost()
    this.fetchQA()
    this.fetchPoll()
  },

  methods: {
    fetchPost(append = false) {
      //  this.loading = true ;
      UserRepository.getFavoritesPost(this.currentPagePost, this.limit, this.currentCircle.id, this.viewUser)
        .then(res => {
          //   this.loading = false ;
          this.showNo = true
          if (append) {
            this.favoritePost.push(...res.data.data.data)
          } else {
            if (res.data) {
              this.favoritePost = res.data.data.data
              this.paginationPost = res.data.data.paginator
            }
          }
          this.currentPagePost += 1
          console.log(this.favoritePost, "log favorite posts------>")
        })
        .catch(err => {})
    },
    fetchQA(append = false) {
      // this.loading = true ;
      UserRepository.getFavoritesQA(this.currentPageQA, this.limit, this.currentCircle.id, this.viewUser)
        .then(res => {
          // this.loading = false ;
          this.showNo = true
          if (append) {
            this.favoriteQA.push(...res.data.data.data)
          } else {
            if (res.data) {
              this.favoriteQA = res.data.data.data
              this.paginationQA = res.data.data.paginator
            }
          }
          this.currentPageQA += 1
          console.log(this.favoriteQA, "log favorites QA------>")
        })
        .catch(err => {})
    },
    fetchPoll(append = false) {
      // this.loading = true ;
      UserRepository.getFavoritesPolls(this.currentPagePoll, this.limit, this.currentCircle.id, this.viewUser)
        .then(res => {
          // this.loading = false ;
          this.showNo = true
          if (append) {
            this.favoritePoll.push(...res.data.data.data)
          } else {
            if (res.data) {
              this.favoritePoll = res.data.data.data
              this.paginationPoll = res.data.data.paginator
            }
          }
          this.currentPageQA += 1
          console.log(this.favoritePoll, "log favorites Poll------>")
        })
        .catch(err => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.contq {
  display: flex;
  gap: 80px;
  flex-direction: column;
}

.viewmore {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  gap: 4px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 20px;
  background: #f1f5f9;
  border-radius: 8px;
}
.get-started-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  height: 48px;
  background: #062b54;
  border-radius: 6px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  text-transform: capitalize;
  color: #ffffff;
  border: none;
}

.dailog {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #33415f;
}

.dailog-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 100%;
  // height: 115px;
}

.dailogbox {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 24px;
  width: 100%;
  // height: 163px;
  background: #f1f5f9;
  border-radius: 8px;
}

.title {
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #0f1734;
  margin-bottom: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Doctor/view/ViewDoctorFavorites.vue